/* eslint-disable eqeqeq */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import './favorites_ig.scss';
import { httpGet, httpGetPlain } from '../../../store/externalCalls/httpCalls';

const Favorites_IG = (props) => {
  const { } = props;

  const [configId, setConfigId] = useState('1');
  const [url] = useState('xtadium-calendar/config/');
  const [iframeUrl, setIframeUrl] = useState(process.env.REACT_APP_BACKEND_URL + url + configId);

  const [errorMsg, setErrorMsg] = useState('');
  const [okMsg, setOkMsg] = useState('');

  const [message, setMessage] = useState(`{
            "type": "xms-send-calendar-info",
            "payload": {
                "favouriteIds": [3383, 3384],
                "restrictedIds": [],
                "vtProviderIds": []
            }
        }`);

  const iframeRef = useRef();

  useEffect(() => { }, []);
 
  const handlerChangeUrl = (e) => setIframeUrl(e.target.value);
  const handlerChangeConfigId = (e) => {
    const val = e.target.value;
    setConfigId(val);
    setIframeUrl(process.env.REACT_APP_BACKEND_URL + url + val);
  };
  const handlerSendInfo=(e)=>{

    // console.log("send info");
    const iframe = iframeRef.current;
    const iframeWindow = iframe?.contentWindow;
    if (!iframeWindow) return;
    const cleanMessage = message.replace(/\n/g, '').replace(/\s+/g, ' ');
    iframeWindow.postMessage(cleanMessage, process.env.REACT_APP_BACKEND_URL);
  }
  const handlerLoadUrl = () => {
    fetchIframeResponseCode(iframeUrl)
      .then((r) => {
        if (r == 'ok') {
          iframeRef.current.src = iframeUrl;
          
        } else {
          setErrorMsg(r);
        }
      })
      .catch((error) => {
        const msg = 'Unknown error ' + JSON.stringify(error);
        setErrorMsg(msg);
        setTimeout(() => setErrorMsg(''), 2000);
      });
  };
  async function fetchIframeResponseCode(url) {
    return new Promise((resolve, reject) => {
      fetch(url, { method: 'GET' })
        .then((res) => {
          if (res.status == 200) resolve('ok');
          else resolve('There is a bad statuscode ' + res.status);
        })
        .catch((error) => reject(error.message));
    });
  }
  const handlerOnChangeMessage=(e)=>{
    setMessage(e.target.value);
  }
  return (
    <div className="fox-scoreboards">
      <h2 className="title">Favorites Monitor</h2>
      <div className="topGrid">
        <div className="card">
          <div className="cardHeader">
            <div className="block-title">Load Favorites IG</div>

          </div>

          <div className="cardBody">
            <form className="formCompact">
              <div className="field">
                <label htmlFor="contentId">ConfigId</label>
                <input
                  className="inputSm"
                  type="text"
                  id="contentId"
                  name="contentId"
                  value={configId}
                  onChange={handlerChangeConfigId}
                />
              </div>

              <div className="field">
                <label htmlFor="scoreboardUrl">Url</label>
                <input
                  className="inputSm"
                  type="text"
                  id="scoreboardUrl"
                  name="scoreboardUrl"
                  value={iframeUrl}
                  placeholder="URL/league/contentId/cameraSelected"
                  onChange={handlerChangeUrl}
                />
              </div>

              <div className="row2">
              </div>
              <div className="row3">
              </div>
              <div className="rowButtons">
                <button className="btn btnPrimary btnWide" type="button" onClick={handlerLoadUrl}>
                  LOAD IG
                </button>
              </div>
              {errorMsg ? <div className="alert alertError">{errorMsg}</div> : null}
              {okMsg ? <div className="alert alertOk">{okMsg}</div> : null}
            </form>
          </div>
        </div>
        <div className="card">
          <div className="cardHeader">
            <div className="block-title">Send info to Interactable</div>
            {/* <div className="counter">{websocketSCOREBOARDCounter}</div> */}
          </div>
          <div className="cardBody">
            <textarea onChange={handlerOnChangeMessage} value={message} rows="8" cols="60" ></textarea>
            <button className="btn btnPrimary btnWide" type="button" onClick={handlerSendInfo}>
                  Send info to IG
                </button>

          </div>
        </div>
      </div>
      <div className="iframeFull">
        <div className="iframeHeader">
          <div className="block-title">Live Preview</div>
          <div className="hint">Iframe</div>
        </div>
        <iframe ref={iframeRef} id="myIframe" title="scoreboard-iframe" />
      </div>
    </div>
  );
};

export default Favorites_IG;
